import {
  AlertEntry,
  AlertObject,
  JobsResponse,
  ProjectObject,
} from '../TypeScript/interfaces';
import { Context, createContext } from 'react';
import { LitholensLocalDatabaseType } from '../utils/db/database';

export interface AppContextType {
  user: {
    username: string;
    signInUserSession: {
      idToken: {
        payload: any;
      };
      getIdToken: () => {
        getJwtToken: () => string;
      };
    };
    attributes?: any;
    userDataKey?: string;
  };
  company: string; // for switching companies
  setCompany: (value: string | '') => void;
  appLoading: boolean;
  /**
   * Displays a full page overlay with a loading icon and
   * disables user interaction.
   * @param value Displays an overlay when true
   * @returns void
   */
  setAppLoading: (value: boolean) => void;
  /**
   * Displays message within the overlay.
   * Hidden if value is an empty string.
   * @param value Message to display
   * @returns void
   */
  setAppLoadingMessage: (value: string) => void;
  /**
   * Displays progress percent 0 to 100 within the overlay.
   * Hidden if value is -1.
   * @param value Percent of progress
   * @returns void
   */
  setAppLoadingProgress: (value: number) => void;
  activeProject: ProjectObject;
  setActiveProject: (value: ProjectObject | {}) => void;
  refreshProjectObject: (projectId?: string) => Promise<void>;
  activeJob: JobsResponse;
  setActiveJob: (value: JobsResponse) => void;
  db?: LitholensLocalDatabaseType;
}

export const appContext: Context<AppContextType> =
  createContext<AppContextType>({
    user: {} as {
      username: string;
      signInUserSession: {
        idToken: {
          payload: any;
        };
        getIdToken: () => {
          getJwtToken: () => string;
        };
      };
      attributes?: any;
      userDataKey?: string;
    },
    company: '', // for switching companies
    setCompany: (_value: string) => {},
    appLoading: false,
    setAppLoading: (_value: boolean): void => {},
    setAppLoadingMessage: (_value: string): void => {},
    setAppLoadingProgress: (_value: number): void => {},
    // The project is selected via URL
    activeProject: {},
    setActiveProject: (_value: ProjectObject): void => {},
    refreshProjectObject: (_projectId?: string): Promise<void> => {
      return new Promise((resolve, reject) => {
        resolve();
      });
    },
    activeJob: {
      company: '',
      description: '',
      id: '',
      project: '',
    },
    setActiveJob: (_value: JobsResponse): void => {},
  });
